function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '../private/SvgIcon';
function createSvgIcon(path, displayName) {
  const Component = (props, ref) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
    "data-testid": `${displayName}Icon`,
    ref: ref
  }, props), path);
  Component.displayName = displayName;
  return /*#__PURE__*/React.forwardRef(Component);
}
export default createSvgIcon;
//# sourceMappingURL=createSvgIcon.js.map